// removed by extract-text-webpack-plugin
module.exports = {"header":"src-components-Header----index-module---header---239p4","brand":"src-components-Header----index-module---brand---W89Yh","logo":"src-components-Header----index-module---logo---1kTSE","nav":"src-components-Header----index-module---nav---36zix","navlink":"src-components-Header----index-module---navlink---1SdJI","burgerLink":"src-components-Header----index-module---burgerLink---3egJA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/index.module.css
// module id = 335
// module chunks = 114276838955818